import { Text } from '@chakra-ui/react';
import { CopyIcon, DropdownItem } from 'ui-components';
import { ICreator } from '~/types';

interface ICopyEmbedDropdownItemProps {
  creator: ICreator;
  onBasicCopy: (e: React.MouseEvent) => Promise<void> | void;
  onDetailCopy: (e: React.MouseEvent) => Promise<void> | void;
}

export const CopyEmbedDropdownItem: React.FC<ICopyEmbedDropdownItemProps> = ({
  creator,
  onBasicCopy,
  onDetailCopy,
}) => (
  <>
    <DropdownItem onClick={onBasicCopy} trackId="wm-creator-copy-basic-embed">
      <CopyIcon boxSize={4} />
      <Text>Copy Basic Embed</Text>
    </DropdownItem>

    {!creator?.isOffPlatform && creator?.hasConnectedPlatform && (
      <DropdownItem
        track-id="wm-creator-copy-detail-embed"
        onClick={onDetailCopy}
      >
        <CopyIcon boxSize={4} />
        <Text>Copy Detail Embed</Text>
      </DropdownItem>
    )}
  </>
);
